import {
  TRIMET_STREETS_LAYER,
  TRIMET_3D_LAYER,
  TRIMET_DARK_LAYER,
  TRIMET_DARK_3D_LAYER,
  TRIMET_SATELLITE_LAYER,
  TRIMET_SATELLITE_ROUTES_LAYER,
} from '#/map/constants';

const TILES_BASE_URL = 'https://tiles.trimet.org/styles';

export default {
  // Enabled Map Views
  views: [
    {
      type: 'DEFAULT',
      text: 'Map View',
    },
  ],
  // Default Map Center
  initLat: 45.52,
  initLon: -122.682,
  // Initial zoom level of the map for mobile and desktop
  initZoom: {
    mobile: 12,
    desktop: 14,
  },
  // The permitted boundaries for the map.  These values are expanded slightly so
  // that (with the permanent padding applied in MapContainer) the full view
  // can still include Saint Helens in the north-west and Idanha in the
  // south-east when zoomed all the way out.
  mapLimits: {
    top: 46.1, // just north of St. Helens
    bottom: 44.6, // just south of Idanha
    left: -124.0, // just west of the Oregon Coast
    right: -120.0, // just east of Mt. Hood’s foothills
  },
  // Starting map height on mobile as percentage of the viewport
  minMapPercentageMobile: 50,
  // The max height on mobile as percentage of the viewport
  maxMapPercentageMobile: 80,
  maxZoom: 20,
  minZoom: 8,

  /* Value used as height and width for bounds generated around a point of interest
  used as the extent when zooming to that marker, in meters */
  poiBoundsExtent: 400,
  // Interval at which realtime vehicles are updated
  realtimeVehicleRefreshInterval: 5000,
  // Determines if realtime vehicles are toggled on by default
  realtimeVehiclesToggled: true,
  // See https://tiles.trimet.org/ for more information
  layers: [
    {
      url: `${TILES_BASE_URL}/trimet/style.json`,
      name: 'TriMet',
      id: TRIMET_STREETS_LAYER,
    },
    {
      url: `${TILES_BASE_URL}/trimet-3d/style.json`,
      name: 'TriMet 3D',
      id: TRIMET_3D_LAYER,
    },
    {
      url: `${TILES_BASE_URL}/trimet-dark/style.json`,
      name: 'TriMet Dark',
      id: TRIMET_DARK_LAYER,
    },
    {
      url: `${TILES_BASE_URL}/trimet-dark-3d/style.json`,
      name: 'TriMet Dark 3D',
      id: TRIMET_DARK_3D_LAYER,
    },
    {
      url: `${TILES_BASE_URL}/trimet-satellite/style.json`,
      name: 'TriMet Satellite',
      id: TRIMET_SATELLITE_LAYER,
    },
    {
      url: `${TILES_BASE_URL}/trimet-satellite-routes/style.json`,
      name: 'TriMet Satellite Routes',
      id: TRIMET_SATELLITE_ROUTES_LAYER,
    },
  ],
};
